
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class IncomeTaxSlabDetailsGrid extends _Ext.GridBase<IncomeTaxSlabDetailsRow, any> {
        protected getColumnsKey() { return 'HR.IncomeTaxSlabDetails'; }
        protected getDialogType() { return IncomeTaxSlabDetailsDialog; }
        protected getIdProperty() { return IncomeTaxSlabDetailsRow.idProperty; }
        protected getInsertPermission() { return IncomeTaxSlabDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return IncomeTaxSlabDetailsRow.localTextPrefix; }
        protected getService() { return IncomeTaxSlabDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}